import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerImageAndContentContainerConverter extends CmsConverterService<ColorContainerImageAndContentContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      headline: formData.st_headline ?? defaultTextInput,
      enableCaption: formData.st_enable_caption?.value ?? false,
      caption: formData.st_caption ?? defaultTextInput,
      captionColor: formData.st_caption_color?.value?.identifier ?? '',
      disableDetailsView: formData.st_disable_image_details_view?.value ?? false,
      overlayCaption: formData.st_caption_overlay ?? defaultTextInput,
      overlayDescription: formData.st_description_overlay ?? defaultTextInput,
      alignImage: formData.st_align_image?.value?.identifier ?? '',
      text: formData.st_text ?? defaultTextInput,
      textCentered: formData.st_centered_text?.value ?? false,
      spacing: {
        top: formData.st_spacing_bottom?.value?.identifier ?? '',
        bottom: formData.st_spacing_top?.value?.identifier ?? ''
      },
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const COLOR_CONTAINER_IMAGE_AND_CONTENT_CONTAINER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent,
  ColorContainerImageAndContentContainerData>>('ColorContainerImageAndContentContainerConverter')

export interface ColorContainerImageAndContentContainerData extends ConvertedComponentData {
  alignImage: string;
  image: Image;
  headline: TextInput;
  captionColor: string;
  caption: TextInput;
  disableDetailsView: boolean;
  enableCaption: boolean;
  overlayCaption: TextInput;
  overlayDescription: TextInput;
  textCentered: boolean;
  text: TextInput;
  spacing: Spacing;
  items: FsCatalog;
}
